module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.ttf
// module chunks = 2